import {
  GetCurrentUserRequestSchema,
  GetCurrentUserResponseSchema,
  PetriService,
} from 'petri/service_pb';

// How do we do this in a way that doesn't require hardcoding these? Or at least checks them?
export const BACKENDS = {
  'petri.PetriService': {
    service: PetriService,
    methods: {
      getCurrentUser: [
        GetCurrentUserRequestSchema,
        GetCurrentUserResponseSchema,
      ],
    },
  },
} as const;

export const REQUEST_TYPES = new Map(
  Object.entries(BACKENDS).flatMap(([typeName, {methods}]) =>
    Object.entries(methods).map(([method, [request]]) => [
      `${typeName}/${method.charAt(0).toUpperCase() + method.slice(1)}`,
      request,
    ]),
  ),
);

export const RESPONSE_TYPES = new Map(
  Object.entries(BACKENDS).flatMap(([typeName, {methods}]) =>
    Object.entries(methods).map(([method, [, response]]) => [
      `${typeName}/${method.charAt(0).toUpperCase() + method.slice(1)}`,
      response,
    ]),
  ),
);
